export const testIds = {
	importButton: 'rate-card-csv-import',
	exportButton: 'rate-card-csv-export',
	acknowledgeCheckbox: 'rate-card-csv-acknowledge-checkbox'
};
